"use client";
import { TContentType } from "@/contexts/globalSearch";
import { IOperation } from "@/types/operation";
import { IPage } from "@/types/page";
import { IPost } from "@/types/post";
import { contentTypesNiceNameSingular } from "@/utils/contentTypes";
import Link from "next/link";
import { useRouter } from "next/navigation";

export const EntrySmallCard = ({ entry }: { entry: IPost }) => {
  const router = useRouter();
  if (!entry) return null;
  return (
    <div className="grid grid-cols-12 gap-4 xl:gap-8 group">
      <div
        className="col-span-4 bg-gray-100 overflow-hidden cursor-pointer"
        onClick={() => router.push(`/post/${entry.slug}`)}
      >
        {entry.image && entry.image.url && (
          <img
            src={`${entry.image.url}?w=350&h=200&fit=fill`}
            alt={entry.image.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        )}
      </div>
      <div className="col-span-8 space-y-4">
        {entry.contentfulMetadata && (
          <div className="flex">
            <p className="uppercase text-xs font-medium tracking-wide border-b-2 border-b-gray-600">
              {entry.contentfulMetadata?.tags.map((tag) => tag.name).join(", ")}
            </p>
          </div>
        )}
        <div className="line-clamp-3">
          <Link
            className="font-light block group-hover:underline"
            href={`/post/${entry.slug}`}
          >
            {entry.title}
          </Link>
        </div>
      </div>
    </div>
  );
};

export const SearchEntrySmallCard = ({
  entry,
}: {
  entry: IPost | IPage | IOperation;
}) => {
  const router = useRouter();
  if (!entry) return null;
  return (
    <div className="grid grid-cols-12 gap-4 xl:gap-8 group">
      <div
        className="col-span-4 bg-gray-100 overflow-hidden cursor-pointer"
        onClick={() =>
          router.push(
            `/${entry.__typename === "Operation" ? `operations` : `post`}/${
              entry.slug
            }`
          )
        }
      >
        {entry.image && entry.image.url && (
          <img
            src={`${entry.image.url}?w=350&h=200&fit=fill`}
            alt={entry.image.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        )}
      </div>
      <div className="col-span-8 space-y-4">
        <div className="flex">
          <p className="uppercase text-xs font-medium tracking-wide border-b-2 border-b-gray-600">
            {/* {entry.contentfulMetadata?.tags.map((tag) => tag.name).join(", ")} */}
            {contentTypesNiceNameSingular(entry.__typename as TContentType)}
          </p>
        </div>
        <div className="line-clamp-3">
          <Link
            className="font-light block group-hover:underline"
            href={`/${
              entry.__typename === "Operation" ? `operations` : `post`
            }/${entry.slug}`}
          >
            {entry.title}
          </Link>
        </div>
      </div>
    </div>
  );
};
